module.exports = __webpack_public_path__ + "media/images/flags/16/Gabon-cdd75aca799fc264630fab75b7fbfd84.png";